<template>
    <div :class="{ gray: isGray }">
        <div
            v-if="isDesktopWeiXin"
            class="wx-browser"
        >
            <p class="text">
                请在新打开的页面操作，或点击“登录”按钮手动跳转，或在浏览器中访问以下网址:
            </p>
            <p class="text">
                {{ pumaPortalURL }}
            </p>
            <el-button
                :disabled="!isWeixinReady"
                @click="onClickWxLogin"
                type="primary"
                size="large"
            >
                登录
            </el-button>
        </div>
        <template v-else-if="isNotDesktopWeiXin && show">
            <router-view />
        </template>
    </div>
</template>

<script>
import { isArray } from 'lodash/lang';
import { mapState } from 'vuex';
import queryString from 'query-string';
import * as authHelper from '@/helper/auth';
import * as wxHelper from '@/helper/wx';
import * as utilsHelper from '@/helper/utils';
import * as authApi from '@/api/auth';
import * as commonApi from '@/api/index';
import { SECOND_AUTH_CARD } from '@/components/SecondAuth/consts';
import secondAuthMixin from '@/components/SecondAuth/mixin';
import { isOAUrl } from '@/components/Login/mixin/helper';
import axios from 'axios';
import { canThreePartyLogin } from '@/components/Login/Login';

// 这里 hash 值需提前解析并做一个快照，否则会丢失(暂未找到原因)
export function parseHash(hash = '') {
    try {
        return queryString.parse(window.location.hash.split('?')[1]);
    } catch (e) {
        console.error(e);
        return {};
    }
}

const { agentId } = wxHelper.getWXConfigByDomain();

export default {
    name: 'App',
    mixins: [secondAuthMixin],
    data() {
        return {
            reopenUrl: '',
            pumaPortalURL: window.XCConfig.VUE_APP_PORTAL_URL_NEW,
            isWeixinReady: false,
            show: true,
            isDesktopWeiXin: this.$_isDesktopWeiXin(),
            isNotDesktopWeiXin: !this.$_isDesktopWeiXin(),
        };
    },
    computed: {
        ...mapState(['puma', ['user']]),
        isGray() {
            return this.$store.state.isGray;
        },
        isMobile() {
            let u = navigator.userAgent;
            return !!u.match(/AppleWebKit.*Mobile.*/);
        },
    },
    watch: {
        $route: function(v) {
            if (['/login', '/welcome'].includes(v.path)) {
                this.getGrayVal();
            }
        },
    },
    async created() {
        const hash = parseHash(window.location.hash);
        this.reopenUrl = this.getWxRedirectUrl(hash);

        // 不允许在 '桌面版本' 的 '微信' 内置浏览中使用
        if (this.$_isDesktopWeiXin()) {
            await this.wxInit();
            return;
        }
        if (this.$_isMobileWeiXin() && isOAUrl(window.location.href)) {
            this.show = false;
            if (window.XCConfig.VUE_APP_ENV === 'prod') {
                window.location.href
                    = 'https://oa.xinchao.com:9000/wxapi/wxclientmenu/e1872d53d46940dd8dc4332eb2f00440';
            } else {
                window.location.href
                    = 'http://oa-test-e9.xinchao.com:8999/wxapi/wxclientmenu/3f32104cd6894ce7a7c4222aa8ac905c';
            }
            return;
        }
        await this.$store.dispatch('setSessionId');
        if (authHelper.isLoggedIn()) {// cookie 中是否存在token
            const { query, path } = this.$route;
            if (!canThreePartyLogin(query) && path !== '/login') { // 如果不是三方登录，并且不是登录页，则继续
                try {
                    this.$log(`loggedIn userInfo: ${this.user?.code}`);
                } catch (e) {
                    console.warn(e);
                }

                const messageId = hash['message_id'];
                if (messageId) {
                    try {
                        await commonApi.msgClick({ id: messageId });
                        // eslint-disable-next-line no-empty
                    } catch (e) { }
                }
                await this.$store.dispatch('reloadInitData');
            }
        }

        // 如果 user.passSecondAuth 中存在 UKEY 则需要恢复拔出事件
        const { passSecondAuth } = this.user;
        if (isArray(passSecondAuth) && passSecondAuth.indexOf(SECOND_AUTH_CARD) !== -1) {
            this.$_regPullCardLogout();
        }
        // this.getGrayVal();
    },
    methods: {
        getGrayVal() {
            axios.get('https://puma-root.obs.cn-east-2.myhuaweicloud.com/ash/app_gray_config.json').then((res) => {
                if (res && res.data) {
                    if (+res.data === 1) {
                        this.$store.dispatch('setIsGray', !this.isMobile);
                    } else {
                        this.$store.dispatch('setIsGray', false);
                    }
                }
            });
        },
        getWxRedirectUrl(params = {}) {
            const messageId = params['message_id'];
            const redirect = params['redirect'];
            const extraParams = {};
            if (messageId) {
                // 这里 key 不能省略，稍后会作为 key 拼接到 url 中
                extraParams['message_id'] = messageId;
            }
            return wxHelper.getWXOauthUrl(redirect, extraParams);
        },
        async onClickWxLogin() {
            await this.wxOpenInDefaultBrowser();
        },
        async wxInit() {
            await utilsHelper.loadScript('https://res.wx.qq.com/open/js/jweixin-1.2.0.js');

            const crtUrl = utilsHelper.getCrtUrl(window);
            let res;
            try {
                res = await authApi.wxSign(agentId, encodeURIComponent(crtUrl));
            } catch (e) {
                this.$message.error('获取微信签名失败，请按提示，手动复制链接地址在浏览器中打开');
                return;
            }

            window.wx.config({
                beta: true,
                // 禁止弹出 alert
                debug: false,
                appId: window.XCConfig.VUE_APP_WX_APPID,
                timestamp: res.timestamp,
                nonceStr: res.nonceStr,
                signature: res.ticket,
                jsApiList: ['openDefaultBrowser', 'closeWindow'],
            });

            window.wx.ready(async() => {
                this.isWeixinReady = true;
                await this.wxOpenInDefaultBrowser();
            });
            window.wx.error((res) => {
                this.$message.error('微信配置失败，请按提示，手动复制链接地址在浏览器中打开');
            });
        },
        async wxOpenInDefaultBrowser() {
            window.wx.checkJsApi({
                jsApiList: ['openDefaultBrowser'],
                success: ({ checkResult }) => {
                    if (!checkResult['openDefaultBrowser']) {
                        this.$message.error('微信授权失败，请按提示，手动复制链接地址在浏览器中打开');
                        return;
                    } else {
                        window.wx.invoke(
                            'openDefaultBrowser',
                            {
                                url: this.reopenUrl,
                            },
                            (res) => {
                                if (res.err_msg !== 'openDefaultBrowser:ok') {
                                    this.$message.error('微信跳转操作失败，请稍后重试');
                                } else {
                                    window.wx.invoke('closeWindow');
                                }
                            }
                        );
                    }
                },
            });
        },
        $_isDesktopWeiXin() {
            return wxHelper.isDesktopWX(window.navigator.userAgent);
        },
        $_isMobileWeiXin() {
            return wxHelper.isMobileWX(window.navigator.userAgent);
        },
    },
};
</script>

<style lang="scss">
.gray {
    -webkit-filter: grayscale(100%);
    filter: grayscale(1);
}

.wx-browser {
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;

    .text {
        font-size: 16px;
        margin-bottom: 20px;
    }
}

.top-bar {
    height: 40px;
    width: 100%;
}
</style>
